import {DrawingDataItem, DrawingDataItemDrawResult, DrawingDataItemPoint} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemTriangle extends DrawingDataItem {
    constructor() {
        super();
        this.typeValue = 'triangle';
        this.properties = {
            location: undefined
        }
    }

    public getPointsToMove(): DrawingDataItemPoint[] {
        return [
            DrawingDataItemPoint.fromVisiblePoint(this.properties.location)
        ]
    }

    onMouseDbClick(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        this.properties.location = {
            x: canvasRelativeX,
            y: canvasRelativeY
        };
        return {
            stillDrawing: false,
            changed: true
        };
    }

    draw(ctx: CanvasRenderingContext2D) {
        const size = this.common.size;
        const location = this.properties.location;
        if (location) {
            ctx.beginPath();
            this.applyCommonToCanvas(ctx);
            ctx.moveTo(location.x - size / 2, location.y + size / 2 );
            ctx.lineTo(location.x, location.y - size / 2);
            ctx.lineTo(location.x + size / 2, location.y + size / 2);
            ctx.closePath();
            ctx.stroke();
        }
    }
}